import { Component, Input } from '@angular/core';
import { ScreenSizeAwareComponent } from '../../common-bases/screen-size-aware-component';
import { Store } from '@ngrx/store';
import { CloseSidenavAction } from '../sidenav.actions';
import { FacebookFormConfiguration } from 'src/app/core/models/social-forms-configurations/facebook-form-configuration.model';
import { UserPermission } from 'src/app/core/enums/user/user-permission.enum';
import { userProfile } from 'src/app/shared/user/user.selectors';

@Component({
    selector: 'app-sidenav-content-facebook-form-container',
    templateUrl: './sidenav-content-facebook-form-container.component.html',
    styleUrls: ['./sidenav-content-facebook-form-container.component.scss'],
    standalone: false
})
export class SidenavContentFacebookFormContainerComponent extends ScreenSizeAwareComponent {

  @Input() set configurationInfo(info: FacebookFormConfiguration | null) {
    if (info) this.isCreatingNewForm = info.id == 0
    else this.isCreatingNewForm = false

    this.facebookConfiguration = info
  }

  isCreatingNewForm = false

  facebookConfiguration: FacebookFormConfiguration | null = null

  userPermission = UserPermission

  user$ = this.appStore.pipe(userProfile)

  constructor(private readonly appStore: Store) {
    super();
    this.user$.subscribe(x => console.log(x))
  }

  onCloseClick() {
    this.appStore.dispatch(CloseSidenavAction())
  }
}
